"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _isOriPackageJson = require("./isOriPackageJson");
Object.keys(_isOriPackageJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isOriPackageJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isOriPackageJson[key];
    }
  });
});
var _isPackageJson = require("./isPackageJson");
Object.keys(_isPackageJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isPackageJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isPackageJson[key];
    }
  });
});
var _readFile = require("./readFile");
Object.keys(_readFile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _readFile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _readFile[key];
    }
  });
});
var _readJson = require("./readJson");
Object.keys(_readJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _readJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _readJson[key];
    }
  });
});
var _readPackageJson = require("./readPackageJson");
Object.keys(_readPackageJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _readPackageJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _readPackageJson[key];
    }
  });
});
var _zodIssuesToString = require("./zodIssuesToString");
Object.keys(_zodIssuesToString).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _zodIssuesToString[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _zodIssuesToString[key];
    }
  });
});
//# sourceMappingURL=index.js.map